import workspaceQuery from '../../../graphql/queries/product/ProductNoteTypeWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/product/ProductNoteTypeListQuery.graphql';
import instanceQuery from '../../../graphql/queries/product/ProductNoteTypeQuery.graphql';
import defaultQuery from '../../../graphql/queries/product/ProductNoteTypeDefault.graphql';
import mutationQuery from '../../../graphql/mutations/product/ProductNoteTypeMutation.graphql';
import fragment from '../../../graphql/fragments/product/ProductNoteTypeFragment.graphql';
import { Direction } from '../../schema/p4types';
import { EntityType } from '../../../@types/entityTypes';

const ProductNoteType: EntityType = {
  type: 'ProductNoteType',
  title: 'Product Note Types',
  formTitle: 'Product Note Type',
  formUrl: '/Products/NoteType/Details/',
  workspaceUrl: '/Products/NoteType/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'title',
    customVariables: () => {
      return {
        orderBy: 'title',
        orderDirection: Direction.Asc,
      };
    },
  },
  fragment,
  screenReference: 'PRODUCTS_NOTE_TYPES',
};

export default ProductNoteType;
